module.exports = __webpack_public_path__ + "img/customer_2.3f94c46c.png";